export default __webpack_public_path__ + "static/Plots0068-0b5130781da21ecec3f6efea08406732.jpg";